import React, { useContext, useEffect } from 'react'

import { DataContext } from './DataContext'
import Form from '../../../elem/form/Form'
import FormResultsSummary from '../../../elem/form/FormResultsSummary'
import getFilterParamsFromForm from '../../../../utils/form/getFilterParamsFromForm'
import clearFormFields from '../../../../utils/form/clearFormFields'

const Filter = ({ filterExpanded, syncFilterState, width }) => {
    const {
        filterFields,
        fetchFilterFields,
        fetchResultsCount,
        filterResultsCount,
        filterResultsLoading,
        params,
        setParams,
        setRefinedParams,
        setStoredParams,
        formName,
    } = useContext(DataContext)

    const onSubmit = (data, e) => {
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['well'].SortByField,
            SortOrder: params['well'].SortOrder,
            ...getFilterParamsFromForm(data),
        }
        setParams(newParams, 'well')
        syncFilterState(false)
    }

    const onReset = (getValues, setValue, clearStoredParams = true) => {
        clearFormFields(getValues, setValue)
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['well'].SortByField,
            SortOrder: params['well'].SortOrder,
        }
        setParams(newParams, 'well')
        if (clearStoredParams) {
            setStoredParams([])
            setRefinedParams([])
        }
    }

    const addToResults = (data, resetForm) => {
        // const newParams = {
        //     PageSize: 50,
        //     Page: 1,
        //     SortByField: params['well'].SortByField,
        //     SortOrder: params['well'].SortOrder,
        //     ...getFilterParamsFromForm(data, false),
        // }
        setStoredParams(prev => [
            ...prev,
            { well: getFilterParamsFromForm(data, false) },
        ])
        resetForm()
    }

    // const refineResults = (data, resetForm) => {
    //     // const newParams = {
    //     //     PageSize: 50,
    //     //     Page: 1,
    //     //     SortByField: params['sample'].SortByField,
    //     //     SortOrder: params['sample'].SortOrder,
    //     //     ...getFilterParamsFromForm(data, false),
    //     // }
    //     setRefinedParams(prev => [
    //         ...prev,
    //         { well: getFilterParamsFromForm(data, false) },
    //     ])
    //     resetForm()
    // }

    useEffect(() => {
        fetchFilterFields()
    }, [])

    return (
        <>
            <FormResultsSummary
                name={formName}
                filterResultsCount={filterResultsCount}
                filterResultsLoading={filterResultsLoading}
                filterExpanded={filterExpanded}
            />
            <div
                className={`explorerFilter ${
                    filterExpanded ? 'is-visible' : 'is-hidden'
                }`}
            >
                <div className="content">
                    <Form
                        formWidth={width}
                        formName={formName}
                        formFields={filterFields}
                        onSubmit={onSubmit}
                        onReset={onReset}
                        onChange={fetchResultsCount}
                        addToResults={addToResults}
                        refineResults={null}
                        params={params}
                    />
                </div>
            </div>
        </>
    )
}

export default Filter
